import { render, staticRenderFns } from "./NoBillsOverlay.vue?vue&type=template&id=13b5ff4c&scoped=true"
import script from "./NoBillsOverlay.vue?vue&type=script&lang=js"
export * from "./NoBillsOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5ff4c",
  null
  
)

export default component.exports